export const errorMessage = {
  errorNetWork: 'データの表示が失敗しました',
};
